import Page from './Page.container';

export default Page;
